import styled from 'styled-components';

export const StyledContainer = styled.section`
  background: transparent;
  padding: 0;
  width: 100%;
`;
